import type { RelationPermissionsReturn } from '#layers/forms/types/permissions';
import type { UseRelationPermissionsOptions } from './use-relation-permissions-base';
import { computed } from 'vue';
import { useRelationPermissionsBase } from './use-relation-permissions-base';

export function useO2MPermissions(options: UseRelationPermissionsOptions): RelationPermissionsReturn {
	const {
		permissionsStore,
		oppositeColId,
		oppositeConstrainedFieldIds,
	} = useRelationPermissionsBase(options);

	// O2M: Constrained FK on OPPOSITE collection
	return {
		canConnect: computed(() => {
			if (!oppositeColId.value) return false;
			return permissionsStore.canRead(oppositeColId.value)
				&& permissionsStore.canUpdate(oppositeColId.value)
				&& permissionsStore.canUpdateFields(oppositeColId.value, oppositeConstrainedFieldIds.value);
		}),
		canCreate: computed(() => {
			if (!oppositeColId.value) return false;
			return permissionsStore.canCreate(oppositeColId.value)
				&& permissionsStore.canCreateFields(oppositeColId.value, oppositeConstrainedFieldIds.value);
		}),
		canEdit: computed(() => {
			if (!oppositeColId.value) return false;
			return permissionsStore.canUpdate(oppositeColId.value);
		}),
		canDisconnect: computed(() => {
			if (!oppositeColId.value) return false;
			return permissionsStore.canUpdate(oppositeColId.value)
				&& permissionsStore.canUpdateFields(oppositeColId.value, oppositeConstrainedFieldIds.value);
		}),
	};
}
